export const trackTealium = async (...args) => {
  if (typeof window !== 'undefined') {
    const analytics = await import('@shopify/marketing-assets/dist/javascripts/global/analytics');
    return analytics.default.track(...args);
  }
  return Promise.reject();
};
